// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_f4-0";
export var actionModalContentContainer = "_f4-1";
export var createTagButton = "_f4-2";
export var footerContainer = "_f4-7";
export var fullWidthDivider = "_f4-3";
export var hasCreateTagButton = "_f4-4";
export var noCreateTagButton = "_f4-5";
export var tagsContainer = "_f4-6";
export var tagsModalContentContainer = "_f4-8";